export const paginationMiddleware = {
  beforeStart: ({ instance, currentState, params }) => {
    let isFresh = (params?.page || 0) === 0;
    return {
      ...currentState,
      loading: true,
      isLoadingFresh: isFresh,
      data: isFresh ? {} : currentState?.data || {},
    };
  },
  afterSuccess: ({ instance, currentState, response }) => {
    try {
      let newData = { ...(currentState || {}) };
      newData = {
        count: response?.count,
        rows: [...(newData?.data?.rows || []), ...response?.rows],
      };
      return {
        ...currentState,
        data : newData,
        isLoadingFresh: false,
        loading : false,
      };
    } catch (error) {
      console.log("error", error);
    }
  },
};
